module.exports = __webpack_public_path__ + "static/media/dev-how-it-looks.3f73e066.png";